import Vue from 'vue';
import '@/plugins/AzureAuth';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import store from './store';
import router from './router';
import './plugins/portal';
import './plugins/youtube';
import './plugins/dayjs';

Vue.config.productionTip = false;
Vue.config.performance = true;

new Vue({
  store,
  vuetify,
  router,
  render: h => h(App),
}).$mount('#app');
